// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LinkedSystem, LinkedSystemAccLinkingValue } from '../misc/LinkedSystem';
import { QuickTableRactive } from '../elements/QuickTable/QuickTableRactive';
import { PanelLocKeys, PanelNames } from '../UtilsClasses/FactoryConstants';
import { BrowserUtils } from '@shared/utils/BrowserUtils';
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Resources } from '@shared/localizations/Resources';
import { ExportScreen } from '../screen/ExportScreen';
import { DynProperty } from '@shared/commons/DynProperty';
import { DataCache } from '@shared/commons/DataCache';
import { CustomerAccess } from '@shared/commons/CustomerAccess/CustomerAccess';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { PanelItemsFactory } from './PanelItemsFactory';
import { WorkSpaceManager } from '../WorkSpace/WorkSpaceManager';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { ApplicationPanel } from './ApplicationPanel';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class ApplicationPanelWithTable extends ApplicationPanel {
    constructor() {
        super();
        this.quickTableRactive = null;
        this.menuTagDict = []; // контекстное меню quickTable
        this.moreThanOneTTKey = '';
        this.noOneTTKey = '';
        this.NeedCalculateRowCount = true;
        this.headerLocaleKey = '';
        this.rowCount = 0;
        this.InitGroupByColumnIndex = null;
    }
    getType() {
        return null;
    }
    // Init QuickTableRactive
    jbInit() {
        try {
            const PanelInfo = PanelItemsFactory.GetPanelItem(this.getType());
            if (PanelInfo) {
                const myQuickTableRactive = new QuickTableRactive();
                myQuickTableRactive.set('isAttached', this.isAttached());
                this.addControl(myQuickTableRactive, true);
                const qt = myQuickTableRactive.quickTable;
                // TODO
                qt.InitializeDirect(new PanelInfo());
                this.SetColumnsDefaultDisplayIndex(qt);
                this.SetColumnsColouringMode(qt);
                qt.UpdateSortedColumns();
                this.quickTableRactive = myQuickTableRactive;
                this.layoutTable();
                this.OnResize.Subscribe(this.layoutTable, this);
                qt.OnVisibleColumnChanged.Subscribe(this.visibleColumnChanged, this);
                qt.beforeTableContextMenuShowing = this.preparePopup.bind(this);
            }
            this.populateItemsDirect();
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
        }
    }
    LinkSystemHandler(newVal, oldVal, key) {
        super.LinkSystemHandler(newVal, oldVal, key);
        if (!newVal && key === 'isAccountLinkShow') {
            this.filterByAccountNumber();
        }
    }
    getQuickTable() {
        var _a, _b;
        return (_b = (_a = this.quickTableRactive) === null || _a === void 0 ? void 0 : _a.quickTable) !== null && _b !== void 0 ? _b : null;
    }
    populateItemsDirect() { }
    SetColumnsDefaultDisplayIndex(table) { }
    SetColumnsColouringMode(table) { }
    ProcessSetColumnsColouringMode(table, arr, type) {
        for (let i = 0; i < arr.length; i++) {
            const column = table.columns[arr[i]];
            column.ColouringMode = type;
        }
    }
    ShowTotalsStateChange(menuItem) {
        this.UpdateShowTotalsStateChange(menuItem.checked);
    }
    UpdateShowTotalsStateChange(state) {
        const qt = this.getQuickTable();
        if (qt == null) {
            return;
        }
        qt.ShowTotals = state;
        qt.onResize();
    }
    UpdateGroupByState(InitGroupByColumnIndex) {
        const qt = this.getQuickTable();
        if (qt == null) {
            return;
        }
        const groupByContextMenuItem = qt.groupByContextMenuItem;
        if (isNullOrUndefined(groupByContextMenuItem)) {
            return;
        }
        let groupByMenuItem = null;
        for (let i = 0; i < groupByContextMenuItem.subitems.length; i++) {
            const menuItem = groupByContextMenuItem.subitems[i];
            if (menuItem.tag.PRIVATE.index === InitGroupByColumnIndex) {
                groupByMenuItem = menuItem;
                break;
            }
        }
        if (groupByMenuItem != null) {
            groupByMenuItem.checked = true;
            qt.onGroupByMenuItemClicked(groupByMenuItem);
        }
    }
    layoutTable() {
        if (this.quickTableRactive != null) {
            void this.layoutTableResize(this.quickTableRactive);
        }
    }
    layoutTableResize(table) {
        return __awaiter(this, void 0, void 0, function* () {
            yield table.resetSizes();
            yield table.setSizes();
        });
    }
    oncomplete() {
        this.jbInit();
        super.oncomplete();
        if (!isNullOrUndefined(this.quickTableRactive)) {
            this.deserializeDelayedData();
        }
        this.layoutTable();
        if (this.InitGroupByColumnIndex !== null) {
            this.UpdateGroupByState(this.InitGroupByColumnIndex);
        }
        const qt = this.getQuickTable();
        qt === null || qt === void 0 ? void 0 : qt.OnAddItem.Subscribe(this.OnAddItemToQuickTable, this);
        this.observe('attached', this.onAttachedChanged.bind(this));
    }
    OnAddItemToQuickTable(row) {
        if (!LinkedSystem.accLinkingActive) {
            return;
        }
        row.visible = this.isRowVisibleOnAccountLinking(row);
    }
    visibleColumnChanged(columnIndexesArray) {
        const msgData = {};
        msgData.columnIndexesArray = columnIndexesArray; // what's the purpose ?
    }
    clearTable(tableBehavior) {
        const qt = this.getQuickTable();
        if (qt != null) {
            qt.ClearAll();
        }
    }
    preparePopup() {
        this.updateSymbolInfoMenuItem();
    }
    populate(addPanel) {
        if (!addPanel && WorkSpaceManager.needRestoreWS) {
            this.repopulate();
        }
    }
    repopulate() {
        var _a, _b;
        const qt = this.getQuickTable();
        if (qt != null) {
            qt.ClearAll();
            this.visibleColumnChanged(qt.getVisibleColumn());
        }
        (_b = (_a = this.Controls) === null || _a === void 0 ? void 0 : _a.TerceraInstrumentLookup) === null || _b === void 0 ? void 0 : _b.repopulate(true);
    }
    setSize(w, h) {
        super.setSize(w, h);
        this.layoutTable();
    }
    callThemeChange() {
        this.themeChange();
    }
    themeChange() {
        if (this.quickTableRactive) {
            this.quickTableRactive.themeChange();
        }
    }
    localize() {
        var _a;
        super.localize();
        (_a = this.getQuickTable()) === null || _a === void 0 ? void 0 : _a.localize();
    }
    dispose() {
        const qt = this.getQuickTable();
        qt === null || qt === void 0 ? void 0 : qt.OnAddItem.UnSubscribe(this.OnAddItemToQuickTable, this);
        this.OnResize.UnSubscribe(this.layoutTable, this);
        super.dispose();
    }
    Properties() {
        const properties = super.Properties();
        if (!isNullOrUndefined(this.quickTableRactive)) {
            properties.push(new DynProperty('GroupByColumnIndex', this.getQuickTable().groupByColumnIndex, DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
        }
        return properties;
    }
    callBack(newProperties) {
        super.callBack(newProperties);
        this.InitGroupByColumnIndex = DynProperty.getPropValue(newProperties, 'GroupByColumnIndex');
    }
    TickAsync() {
        /* if (this.quickTableRactive && this.getQuickTable().needRedraw) */
        const qt = this.getQuickTable();
        this.quickTableTickAsync(qt);
        this.forceUpdate = false;
    }
    accountLink_In(accId, fromLinkedSystem = false) {
        const isAccountLinkIn = super.accountLink_In(accId, fromLinkedSystem);
        if (!isAccountLinkIn)
            return false;
        this.filterByAccountNumber(accId);
        return true;
    }
    updatePanelHeader() {
        const qt = this.getQuickTable();
        let subItemsCount = qt != null ? qt.getSubItemsRowsCount(false) : 0;
        let rowNumSt = (this.rowCount - subItemsCount).toString(); // - (all FIFO sub items) #80010
        if (LinkedSystem.accLinkingActive &&
            !isNullOrUndefined(this.quickTableRactive) &&
            this.get('canLinkByAccount')) {
            subItemsCount = qt.getSubItemsRowsCount(true);
            const visibleRowCount = qt.visibleRowCount() - subItemsCount; // - (visible FIFO sub items) #80010
            if (DataCache.EnableForceLinkingByAccount()) {
                rowNumSt = `${visibleRowCount}`;
            }
            else {
                rowNumSt = `${visibleRowCount}/${rowNumSt}`;
            }
        }
        void this.set({
            header: Resources.getResource(this.headerLocaleKey) + (this.NeedCalculateRowCount ? `  (${rowNumSt})` : '')
        });
    }
    isRowVisibleOnAccountLinking(row) {
        var _a;
        if (!this.get('canFilterByAccount') || !this.get('canLinkByAccount')) {
            return true;
        }
        const linkAccId = LinkedSystem.getAccount(LinkedSystemAccLinkingValue);
        const rowAcc = (_a = row === null || row === void 0 ? void 0 : row.item) === null || _a === void 0 ? void 0 : _a.GetCurrentAccount();
        return !rowAcc || (rowAcc === null || rowAcc === void 0 ? void 0 : rowAcc.AcctNumber) === linkAccId;
    }
    enableAccountLinking() {
        super.enableAccountLinking();
        const accId = LinkedSystem.getAccount(LinkedSystemAccLinkingValue);
        this.filterByAccountNumber(accId);
    }
    disableAccountLinking() {
        var _a;
        super.disableAccountLinking();
        (_a = this.getQuickTable()) === null || _a === void 0 ? void 0 : _a.setAllRowsVisibility(true);
    }
    filterByAccountNumber(accId = null) {
        const qt = this.getQuickTable();
        if (!this.get('canLinkByAccount') || qt == null || !this.get('canFilterByAccount')) {
            return;
        }
        qt.filterByAccountNumber(accId);
    }
    setVisibleColumns(arr) {
        const qt = this.getQuickTable();
        if (qt == null) {
            return;
        }
        qt.setVisibleColumn(arr);
    }
    /// <summary>
    /// Инструмент выбранный в таблице (первый если их несколько)
    /// </summary>
    getInstrument() {
        var _a, _b, _c;
        const qt = this.getQuickTable();
        if (!((_a = qt === null || qt === void 0 ? void 0 : qt.selectedRowIds) === null || _a === void 0 ? void 0 : _a[0])) {
            return null;
        }
        const row = qt.rows[qt.selectedRowIds[0]];
        return (_c = (_b = row === null || row === void 0 ? void 0 : row.item) === null || _b === void 0 ? void 0 : _b.GetCurrentInstrument()) !== null && _c !== void 0 ? _c : null;
    }
    getSelectedInstruments() {
        var _a, _b, _c;
        const qt = this.getQuickTable();
        if (!((_a = qt === null || qt === void 0 ? void 0 : qt.selectedRowIds) === null || _a === void 0 ? void 0 : _a[0])) {
            return null;
        }
        const listInstruments = [];
        for (const id of qt === null || qt === void 0 ? void 0 : qt.selectedRowIds) {
            const row = qt.rows[id];
            const instrument = (_c = (_b = row === null || row === void 0 ? void 0 : row.item) === null || _b === void 0 ? void 0 : _b.GetCurrentInstrument()) !== null && _c !== void 0 ? _c : null;
            if (instrument) {
                listInstruments.push(instrument);
            }
        }
        return listInstruments;
    }
    openSymbolInfo() {
        const ins = this.getInstrument();
        if (isNullOrUndefined(ins)) {
            return;
        }
        MainWindowManager.MainWindow.ShowSymbolInfo(ins, this.getAccount());
    }
    AddSymbolInfoContextMenuItemIfNeed(items, addSeparator = false) {
        if (CustomerAccess.panelAllowed(PanelNames.SymbolInfoPanel)) {
            if (addSeparator) {
                items.push({ type: NewContextMenuItemType.Separator });
            }
            items.push({
                type: NewContextMenuItemType.Default,
                text: 'panel.watchlist.menu.SymbolInfo',
                event: this.openSymbolInfo.bind(this),
                enabled: false,
                tag: ApplicationPanelWithTable.SYMBOLINFOPANEL
            });
        }
    }
    AddOpeningPanelsCM(items) {
        const lokKeys = this.GetOpeningPanelsCMLocKeysSet();
        let lK = lokKeys[ApplicationPanelWithTable.OPEN_CHART];
        const newItems = [];
        if (!Resources.isHidden(lK)) {
            newItems.push({
                type: NewContextMenuItemType.Default,
                text: lK,
                event: this.openPanel.bind(this, PanelNames.ChartPanel),
                enabled: false,
                tag: ApplicationPanelWithTable.OPEN_CHART
            });
        }
        lK = lokKeys[ApplicationPanelWithTable.OPEN_MD];
        if (!Resources.isHidden(lK)) {
            newItems.push({
                type: NewContextMenuItemType.Default,
                text: lK,
                event: this.openPanel.bind(this, PanelNames.MarketDepthPanel),
                enabled: false,
                tag: ApplicationPanelWithTable.OPEN_MD
            });
        }
        lK = lokKeys[ApplicationPanelWithTable.OPEN_TS];
        if (!Resources.isHidden(lK)) {
            newItems.push({
                type: NewContextMenuItemType.Default,
                text: lK,
                event: this.openPanel.bind(this, PanelNames.TimeSalesPanel),
                enabled: false,
                tag: ApplicationPanelWithTable.OPEN_TS
            });
        }
        lK = lokKeys[ApplicationPanelWithTable.OPEN_OE];
        if (!Resources.isHidden(lK)) {
            newItems.push({
                type: NewContextMenuItemType.Default,
                text: lK,
                event: this.openPanel.bind(this, PanelNames.AdvancedOrderEntry),
                enabled: false,
                tag: ApplicationPanelWithTable.OPEN_OE
            });
        }
        if (newItems.length > 0) {
            newItems.unshift({ type: NewContextMenuItemType.Separator });
            newItems.push({ type: NewContextMenuItemType.Separator });
        }
        return items.concat(newItems);
    }
    NewAddOpeningPanelsCM(items) {
        const lokKeys = this.GetOpeningPanelsCMLocKeysSet();
        let lK = lokKeys[ApplicationPanelWithTable.OPEN_CHART];
        const newItems = [];
        if (!Resources.isHidden(lK)) {
            newItems.push({
                type: NewContextMenuItemType.Default,
                text: lK,
                event: (item) => {
                    this.openPanel(PanelNames.ChartPanel);
                },
                enabled: false,
                tag: ApplicationPanelWithTable.OPEN_CHART
            });
        }
        lK = lokKeys[ApplicationPanelWithTable.OPEN_MD];
        if (!Resources.isHidden(lK)) {
            newItems.push({
                type: NewContextMenuItemType.Default,
                text: lK,
                event: (item) => {
                    this.openPanel(PanelNames.MarketDepthPanel);
                },
                enabled: false,
                tag: ApplicationPanelWithTable.OPEN_MD
            });
        }
        lK = lokKeys[ApplicationPanelWithTable.OPEN_TS];
        if (!Resources.isHidden(lK)) {
            newItems.push({
                type: NewContextMenuItemType.Default,
                text: lK,
                event: (item) => {
                    this.openPanel(PanelNames.TimeSalesPanel);
                },
                enabled: false,
                tag: ApplicationPanelWithTable.OPEN_TS
            });
        }
        lK = lokKeys[ApplicationPanelWithTable.OPEN_OE];
        if (!Resources.isHidden(lK)) {
            newItems.push({
                type: NewContextMenuItemType.Default,
                text: lK,
                event: (item) => {
                    this.openPanel(PanelNames.AdvancedOrderEntry);
                },
                enabled: false,
                tag: ApplicationPanelWithTable.OPEN_OE
            });
        }
        if (newItems.length > 0) {
            newItems.unshift({ type: NewContextMenuItemType.Separator });
            newItems.push({ type: NewContextMenuItemType.Separator });
        }
        items.push(...newItems);
    }
    SetOpeningPanelsCMEnability(menuTagDict, enabled) {
        if (menuTagDict[ApplicationPanelWithTable.OPEN_CHART]) {
            menuTagDict[ApplicationPanelWithTable.OPEN_CHART].enabled = enabled;
        }
        if (menuTagDict[ApplicationPanelWithTable.OPEN_MD]) {
            menuTagDict[ApplicationPanelWithTable.OPEN_MD].enabled = enabled;
        }
        if (menuTagDict[ApplicationPanelWithTable.OPEN_TS]) {
            menuTagDict[ApplicationPanelWithTable.OPEN_TS].enabled = enabled;
        }
        if (menuTagDict[ApplicationPanelWithTable.OPEN_OE]) {
            menuTagDict[ApplicationPanelWithTable.OPEN_OE].enabled = enabled;
        }
    }
    GetOpeningPanelsCMLocKeysSet() {
        return {};
    }
    getSelectedItemsNumber() {
        const qt = this.getQuickTable();
        if (isNullOrUndefined(qt))
            return 0;
        const selectedRowIds = qt.selectedRowIds;
        if ((selectedRowIds === null || selectedRowIds === void 0 ? void 0 : selectedRowIds.length) !== 0) {
            return selectedRowIds.length;
        }
        return 0;
    }
    getSelectedDifferentItemsNumber() {
        var _a, _b;
        const qt = this.getQuickTable();
        if (isNullOrUndefined(qt)) {
            return 0;
        }
        const selRowIds = qt.selectedRowIds;
        if (isNullOrUndefined(selRowIds) || selRowIds.length === 0) {
            return 0;
        }
        const firstItem = this.getInstrument();
        if (isNullOrUndefined(firstItem)) {
            return 0;
        }
        const firstID = firstItem.GetInteriorID();
        for (let i = 1; i < selRowIds.length; i++) {
            // может быть выбрано несколько ордеров(позиций) одного и того же инструмента
            const selRowID = selRowIds[i];
            const row = selRowID ? qt.rows[selRowID] : null;
            const ins = (_b = (_a = row === null || row === void 0 ? void 0 : row.item) === null || _a === void 0 ? void 0 : _a.GetCurrentInstrument()) !== null && _b !== void 0 ? _b : null;
            if (!isNullOrUndefined(ins) || ins.GetInteriorID() !== firstID) {
                // выбраны разные инструменты
                return selRowIds.length; // пока нам достаточно знать, что выбрано хотя бы 2 разных инструмента
            }
        }
        return 1; // нулевой выбранный совпадает с остальными выбранными - это один и тот же инструмент
    }
    AddExportContextMenuItem(items) {
        const hidden = Resources.isHidden('screen.export.visibility');
        if (hidden || isNullOrUndefined(items)) {
            return;
        }
        items.push({
            type: NewContextMenuItemType.Default,
            text: 'screen.export.contextMenu',
            svgImage: 'export',
            event: () => {
                ExportScreen.show(this);
            }
        });
    }
    AddViewContextMenuItem(items) {
        const hidden = Resources.isHidden('contextMenu.Totals.visibility');
        if (hidden || isNullOrUndefined(items)) {
            return;
        }
        items.push({
            type: NewContextMenuItemType.Default,
            text: Resources.getResource('panel.positions.menu.View'),
            svgImage: 'View',
            subitems: [
                {
                    type: NewContextMenuItemType.Default,
                    text: 'panel.positions.menu.ShowTotals',
                    checked: false,
                    canCheck: true,
                    event: this.ShowTotalsStateChange.bind(this)
                }
            ]
        });
    }
    updateSymbolInfoMenuItem() {
        var _a, _b;
        const menuItem = (_b = (_a = this.menuTagDict) === null || _a === void 0 ? void 0 : _a[ApplicationPanelWithTable.SYMBOLINFOPANEL]) !== null && _b !== void 0 ? _b : null;
        this.updateMenuItem(menuItem);
    }
    updateMenuItem(menuItem) {
        if (isNullOrUndefined(menuItem)) {
            return;
        }
        const moreThanOneTTKey = this.moreThanOneTTKey;
        const noOneTTKey = this.noOneTTKey;
        const ins = this.getInstrument();
        const selInsNum = this.getSelectedDifferentItemsNumber();
        const enabled = !!(selInsNum === 1 && !isNullOrUndefined(ins));
        let tooltip = enabled ? '' : Resources.getResource(selInsNum ? moreThanOneTTKey : noOneTTKey);
        if (isNullOrUndefined(ins) && this.getSelectedItemsNumber() > 0) {
            // выбранного инструмента нет у нас в Instruments (к примеру строка по скрытому или удаленному инструменту в Orders history)
            tooltip = Resources.getResource('panel.menu.symbolWasNotFound');
        }
        menuItem.enabled = enabled;
        menuItem.tooltip = tooltip;
        menuItem.svgImage = enabled ? 'infotool' : 'menuError';
    }
    static tableToHtml(cols, rows, tableTitle) {
        const visibleColumns = cols.filter((col) => col.visible && !col.hidden);
        const tableHeader = visibleColumns
            .map((col) => `<th style="border-collapse:collapse;border:thin solid black;">${col.headerText}</th>`)
            .join('');
        const visibleColumnsID = visibleColumns.map((col) => col.PRIVATE.index);
        const tableRows = rows
            .filter((row) => row.visible)
            .map((row) => {
            const cells = visibleColumnsID.map((col) => `<td style="border:none" align="center">${row.cells[col].formattedValue}</td>`);
            return `<tr>${cells.join('')}</tr>`;
        })
            .join('');
        const currentDate = DateTimeUtils.formatDate(new Date(), 'DD.MM.YYYY HH:mm');
        const acc = DataCache.getPrimaryAccount();
        const additionalInfo = `
        <h3>${DataCache.CompanyName || ''}</h3>
        <div style="position:absolute;right:24;width:242;">
            <table width="100%" style="border:none">
                <tr><td>${Resources.getResource('panel.OrderBook.Date')}:</td><td align="right">${currentDate}</td></tr>
                <tr><td>${Resources.getResource('panel.OrderBook.Login')}:</td><td align="right">${DataCache.UserLogin}</td></tr>
                <tr><td>${Resources.getResource('panel.accounts.Owner')}:</td><td align="right">${acc.FirstName} ${acc.LastName}</td></tr>
                <tr><td>${Resources.getResource('property.currency')}:</td><td align="right">${DataCache.getUserBaseCurrency()}</td></tr>
            </table>
        </div><br><br><br><br><br>`;
        return `${additionalInfo}<table width="100%"><caption><h4>${tableTitle}</h4></caption><tr>${tableHeader}</tr>${tableRows}</table>`;
    }
    printTable() {
        const qt = this.getQuickTable();
        const title = Resources.getResource(PanelLocKeys[this.getType()]);
        const printWin = window.open('', '', 'width=' + screen.availWidth + ',height=' + screen.availHeight);
        const doc = printWin.document;
        doc.open();
        doc.write(ApplicationPanelWithTable.tableToHtml(qt.sortedColumns, qt.rowsArray, title));
        doc.close();
        printWin.print();
        const closePrintWin = () => {
            printWin.close();
        };
        if (BrowserUtils.isChrome) {
            printWin.onafterprint = closePrintWin;
        }
        else {
            closePrintWin();
        }
    }
    getCallBackInstrument(properties, propName) {
        const dp = DynProperty.getPropertyByName(properties, propName);
        let symbol = null;
        if (!isNullOrUndefined(dp === null || dp === void 0 ? void 0 : dp.value)) {
            symbol = DataCache.getInstrumentByName(dp.value);
        }
        if (isNullOrUndefined(symbol)) {
            symbol = SessionSettings.getFirstTradableInstrument();
        }
        return symbol;
    }
    // #region ISerializable
    serialize() {
        const serializedData = super.serialize();
        const qt = this.getQuickTable();
        serializedData.table = qt != null ? qt.serialize() : {};
        return serializedData;
    }
    deserialize(serialized) {
        super.deserialize(serialized);
        if (!this.completed) {
            return;
        }
        const qt = this.getQuickTable();
        // Some child classes withot table inherit from ApplicationPanelWithTable. Why?
        if (!isNullOrUndefined(qt)) {
            qt.deserialize(serialized.table);
            this.visibleColumnChanged(qt.getVisibleColumn());
        }
    }
    deserializeOldScheme(serialized) {
        super.deserializeOldScheme(serialized);
        if (!this.completed) {
            return;
        }
        const qt = this.getQuickTable();
        if (!isNullOrUndefined(qt)) {
            qt.deserializeOldScheme(serialized.xmlSettingsTemplate);
            this.visibleColumnChanged(qt.getVisibleColumn());
        }
    }
    // #endregion
    quickTableTickAsync(qt) {
        if (isNullOrUndefined(qt)) {
            return;
        }
        if (qt.rowCountChanged) {
            this.rowCount = qt.getDataRowsCount();
            qt.rowCountChanged = false;
            this.updatePanelHeader();
        }
        if (!this.get('visible')) {
            return;
        }
        qt.updateRowsCellsValues(this.forceUpdate);
        qt.needRedraw = false;
        qt.Draw();
    }
    onAttachedChanged(newVal, oldVal) {
        var _a;
        (_a = this.quickTableRactive) === null || _a === void 0 ? void 0 : _a.set('isAttached', this.isAttached());
        this.themeChange();
    }
}
ApplicationPanelWithTable.OPEN_CHART = 'openChart';
ApplicationPanelWithTable.OPEN_MD = 'openMD';
ApplicationPanelWithTable.OPEN_TS = 'openTS';
ApplicationPanelWithTable.OPEN_OE = 'openOE';
ApplicationPanelWithTable.SYMBOLINFOPANEL = 'SymbolInfoPanel';
ApplicationPanel.extendWith(ApplicationPanelWithTable, {});
